import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

export const autoGeneratePassword = createAsyncThunk('resetPassword/autoGeneratePassword', async (id) => {
  try {
    const response = await axios.post(`GetADDetails/autogenerate?DomainId=${id}`);
    return { status: response.status, data: response.data };
  } catch (err) {
    return err;
  }
});
export const changeRolePassword = createAsyncThunk('changeRolePassword', async (value) => {
  try {
    const response = await axios.put(
      `GetADDetails/changePassword?username=${value.userName}&oldpassword=${value.oldPassword}&newpassword=${value.newPassword}&confirmpassword=${value.confirmPassword}&FQDN=${value.fqdn}`
    );
    return { status: response.status, data: response.data };
  } catch (error) {
    return { data: error.response.data, status: error.response.status };
  }
});

export const bulkPasswordReset = createAsyncThunk('resetPassword/bulkPasswordReset', async (value) => {
  try {
    const response = await axios.put(`GetADDetails/bulkpasswordreset`, value);
    return { status: response.status, data: response.data };
  } catch (error) {
    return { data: error.response.data, status: error.response.status };
  }
});

export const resetLinkforBulkUsers = createAsyncThunk('resetPassword/resetLinkforBulkUsers', async (value) => {
  try {
    const response = await axios.put(`GetADDetails/resetlinkforbulkusers`, value);
    return { status: response.status, data: response.data };
  } catch (error) {
    return { data: error.response.data, status: error.response.status };
  }
});

export const resetUserPassword = createAsyncThunk('resetPassword/resetUserPassword', async (value) => {
  try {
    const response = await axios.put(
      `resetPassword?id=${value.id}&strNewPassword=${value.strNewPassword}&FQDN=${value.fqdn}&DomainId=${value.domainId}`
    );
    return { status: response.status, data: response.data };
  } catch (error) {
    return { data: error.response.data, status: error.response.status };
  }
});
export const forgetUserPassword = createAsyncThunk('forgetPassword/forgetUserPassword', async (value) => {
  try {
    const response = await axios.post(`forgotPassword`, value);
    return { status: response.status, data: response.data };
  } catch (error) {
    return { data: error.response.data, status: error.response.status };
  }
});
export const passwordNextLogon = createAsyncThunk('passwordNextLogon', async (value) => {
  try {
    const response = await axios.put(
      `changePassword?username=${encodeURIComponent(value.userName)}&oldpassword=${value.oldPassword}&newpassword=${
        value.newPassword
      }&confirmpassword=${value.confirmPassword}&FQDN=${value.fqdn}`,
      {});
    return { status: response.status, data: response.data };
  } catch (error) {
    return { data: error.response.data, status: error.response.status };
  }
});
export const resetPasswordStatus = createAsyncThunk('resetPassword/resetPasswordStatus', async (value) => {
  try {
    const response = await axios.post(
      `resetpassowrdstatus?id=${value}`,
      {});
    return { status: response.status, data: response.data };
  } catch (err) {
    return err;
  }
});
const initialState = {
  loading: false,
  error: null,
};

const resetPassword = createSlice({
  name: 'resetUserPassword',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder

      .addCase(resetUserPassword.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(resetUserPassword.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(resetUserPassword.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default resetPassword.reducer;
